import React from 'react';

// component
import HeaderComponent from '../components/header.component';
import FooterComponent from '../components/footer.component';

// pages
import PhoneClient from './phone-client.page';
import ReceiptPage from './receipt.pages';
import NotfoundPage from './notfound.page';

// selector
import { useSelector } from 'react-redux';

// history
import { Redirect } from 'react-router';

import { BrowserRouter, Switch, Route } from 'react-router-dom';
import LoginPage from './login.page';
import PeopleEventPage from './people-event.page';

const HomePage = () => {
  const isReceipt = window.location.href.includes('comprobantes');
  console.log('location', isReceipt);

  const user = useSelector((state) => {
    console.log('state', state);
    return state.default.user;
  });

  return user && user.token ? (
    <BrowserRouter>
      {!isReceipt && <HeaderComponent />}
      <div className='my-3 mx-md-5'>
        <Switch>
          <Route exact path='/'>
            <LoginPage />
          </Route>
          <Route exact path='/phone'>
            <PhoneClient />
          </Route>
          <Route exact path='/comprobantes/:num'>
            <ReceiptPage />
          </Route>
          <Route component={NotfoundPage} />
        </Switch>
      </div>

      {!isReceipt && <FooterComponent />}
    </BrowserRouter>
  ) : (
    <BrowserRouter>
      {!isReceipt && <HeaderComponent />}
      <div className='my-3'>
        <Switch>
          <Route exact path='/eventos/personas'>
            <PeopleEventPage />
          </Route>
          <Route exact path='/comprobantes/:num'>
            <ReceiptPage />
          </Route>
          <Route path='/'>
            <Redirect to='/' />
            <Route exact path='/'>
              <LoginPage />
            </Route>
          </Route>
        </Switch>
      </div>

      {!isReceipt && <FooterComponent />}
    </BrowserRouter>
  );
};

export default HomePage;
